import React, { FC } from 'react';
import { Box, Chip, Paper, Typography } from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { useTranslation } from 'react-i18next';

type LateOrder = {
    orderDisplayId: string;
    mongoId: string;
};

type LateOrdersBannerProps = {
    lateOrders: LateOrder[];
};

const LateOrdersBanner: FC<LateOrdersBannerProps> = ({ lateOrders }) => {
    const { t: translate } = useTranslation(['production-dashboard']);

    if (lateOrders.length === 0) return null;

    return (
        <Paper sx={{ p: 2, mb: 2 }}>
            <Box display="flex" alignItems="center" gap={0.5} mb={0.5}>
                <WarningAmberIcon fontSize="small" color="warning" />
                <Typography variant="subtitle2">
                    {translate('production-dashboard:LATE_ORDERS')} ({lateOrders.length})
                </Typography>
            </Box>
            <Box display="flex" flexWrap="wrap" gap={0.5}>
                {lateOrders.map((o) => (
                    <Chip
                        key={o.orderDisplayId}
                        label={o.orderDisplayId}
                        size="small"
                        clickable
                        onClick={() => window.open(`/order-details/${o.mongoId}/main-view`, '_blank')}
                    />
                ))}
            </Box>
        </Paper>
    );
};

export default LateOrdersBanner;
